import React from 'react'
import { FileBarChart } from 'lucide-react'

const CompanyReports = () => (
  <div className="space-y-6">
    <div className="flex items-center">
      <FileBarChart className="w-6 h-6 text-primary-600 mr-2" />
      <h1 className="text-2xl font-bold text-secondary-900">Reports & Exports</h1>
    </div>
    <div className="card p-6 text-secondary-600">Reports placeholder</div>
  </div>
)

export default CompanyReports


